import angular from 'angular';

import LoginService from './login.service';
import LoginScreen from './login-screen/login-screen.component';
import PermissionDirective from './permissions.directive';
import PermissionService from './permissions.service';
import Routes from './authorization.routes';

const DEPENDENCIES = [
  LoginService,
  LoginScreen,
  PermissionDirective,
  PermissionService,
  'ngRoute',
];

export default angular.module('autoboard.authorization', DEPENDENCIES)
  .config(Routes)
  .name;
